import { useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionUtils";
import NotificationBell from "../modules/settings/notifications/NotificationBell";
import FeedbackButton from "../components/feedback/FeedbackButton";
import HeaderQuickSearch from "./HeaderQuickSearch";
import HeaderAttendanceButton from "./HeaderAttendanceButton";

export default function Header({ user }) {
  const navigate = useNavigate();

  return (
    <div className="h-16 bg-white/80 backdrop-blur-md border-b border-gray-100 flex items-center justify-between gap-6 px-8 sticky top-0 z-[30]">
      <div className="min-w-0 flex-1">
        <HeaderQuickSearch />
      </div>

      <div className="flex shrink-0 items-center gap-4">
        <HeaderAttendanceButton user={user} />
        <div className="hidden h-6 w-px bg-gray-100 md:block" />
        <FeedbackButton />
        {hasPermission("system.notifications", "R") && (
          <NotificationBell onClick={() => navigate("/system/notifications")} />
        )}
      </div>
    </div>
  );
}
